import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "download", -1 /* HOISTED */)
const _hoisted_2 = {
  type: "button",
  disabled: "",
  class: "btn--second btn btn-icon"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons-outlined" }, "backup", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.openModal('export'))),
      type: "button",
      class: "btn--second btn btn-icon"
    }, [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.t$('scheduleDispatcher.btnExport')), 1 /* TEXT */)
    ]),
    _createElementVNode("button", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.t$('scheduleDispatcher.btnUpload')), 1 /* TEXT */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}